import React, { useEffect, useState } from "react";
import { get } from "../../utils/fetchAPI";
import { formatDate } from "../../utils/common-funtions/common";
import Pagination from "react-js-pagination";

export const Log = ({ setShowLogs }) => {
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1)
    const [perPage, setPerPage] = useState(10)
    const [total, setTotal] = useState(0)

    useEffect(() => {
        getList(currentPage, perPage);
    }, []);

    const getList = async (currentPage, perPage = perPage) => {
        setLoading(true);
        await get(`/doctor/sms-logs?current_page=${currentPage}&per_page=${perPage}`)
            .then((res) => {
                if (res.status === 200) {
                    setLogs(res?.data?.data);
                    setTotal(res?.data?.total)
                    setCurrentPage(res?.data?.currentPage)
                    setPerPage(res?.data?.perPage)
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => setLoading(false));
    };

    return (
        <div className="container py-1">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 style={{ color: "#17A980" }} className="fw-bold  mb-0">📩 SMS Logs</h5>
                <div className="d-flex">
                    <button
                        style={{ fontSize: "13px", backgroundColor: "#17A980", color: "white" }}
                        className="btn btn-sm  d-flex align-items-center"
                        onClick={() => setShowLogs(false)}
                        disabled={loading}
                    >
                        <i className="bi bi-arrow-clockwise me-1"></i> Template list
                    </button>
                    <button
                        style={{ fontSize: "13px", backgroundColor: "#17A980", color: "white" }}
                        className="btn btn-sm  d-flex align-items-center mx-2"
                        onClick={() => { getList(1, perPage) }}
                        disabled={loading}
                    >
                        <i className="bi bi-arrow-clockwise me-1"></i> Refresh
                    </button>
                </div>
            </div>
            {/* Loader */}
            {loading && (
                <div className="d-flex justify-content-center py-5">
                    <span className="">Loading...</span>
                </div>
            )}

            {/* Logs */}
            {!loading && (
                <div className="list-group">
                    {logs?.map((data, index) => (
                        <div
                            key={index}
                            className="list-group-item border-0 shadow-sm mb-3 rounded"
                        >
                            {/* First Row: Date, Status & Message */}
                            <div className="d-flex justify-content-between align-items-start mb-2">
                                <small className="text-muted">{formatDate(data?.createdAt)}</small>
                            </div>
                            <p className="small text-dark mb-2">
                                <span className="fw-semibold">Message:</span> {data?.textBody}
                            </p>

                            {/* Second Row: Stats */}
                            <div className="row g-2 text-center small">
                                <div className="col-4 col-md-2">
                                    <div className="bg-light rounded p-2">
                                        <div className="text-muted">Total</div>
                                        <div className="fw-bold">{data?.totalSms}</div>
                                    </div>
                                </div>
                                <div className="col-4 col-md-2">
                                    <div className="bg-light rounded p-2">
                                        <div className="text-muted">Value</div>
                                        <div className="fw-bold">{data?.smsCount}</div>
                                    </div>
                                </div>
                                <div className="col-4 col-md-2">
                                    <div className="bg-light rounded p-2">
                                        <div className="text-muted">Deduct</div>
                                        <div className="fw-bold">
                                            {(data?.sent) * +data?.smsCount}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-4 col-md-2">
                                    <div className="bg-light rounded p-2">
                                        <div className="text-muted">Sent</div>
                                        <div className="fw-bold text-success">{data?.sent}</div>
                                    </div>
                                </div>
                                <div className="col-4 col-md-2">
                                    <div className="bg-light rounded p-2">
                                        <div className="text-muted">Pending</div>
                                        <div className="fw-bold text-warning">{data?.pending}</div>
                                    </div>
                                </div>
                                <div className="col-4 col-md-2">
                                    <div className="bg-light rounded p-2">
                                        <div className="text-muted">Failed</div>
                                        <div className="fw-bold text-danger">{data?.failed}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {!loading && logs?.length === 0 && (
                        <div className="text-center text-muted py-4">No logs found.</div>
                    )}
                    {!loading && logs?.length > 0 && <div className="d-flex justify-content-center">
                        <Pagination
                            activePage={parseInt((currentPage))}
                            itemsCountPerPage={parseInt((perPage))}
                            totalItemsCount={parseInt(total)}
                            // pageRangeDisplayed={5}
                            onChange={(currentPage) => {
                                setCurrentPage(currentPage)
                                getList(currentPage, perPage);
                            }}
                            itemClass="page-item"
                            linkClass="page-link"
                        />
                    </div>}
                </div>
            )}
        </div>
    );
};
